const activateKeepAwake = () => {};
const deactivateKeepAwake = () => {};
const useKeepAwake = () => {};

module.exports = {
  activateKeepAwake,
  deactivateKeepAwake,
  useKeepAwake,
  default: {
    activate: activateKeepAwake,
    deactivate: deactivateKeepAwake,
  },
};
